import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-mdl-delete',
  imports: [],
  templateUrl: './mdl-delete.html',
  styleUrl: './mdl-delete.css'
})
export class MdlDelete {
  public api = inject(Api);
  private alertService = inject(AlertService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlDelete>,
    public router: Router
  ){
    console.log(data.mode);
  }

  delete(){
    if(this.data.mode == 'account'){
      this.deleteAccount();
    }else if(this.data.mode === 'prospect'){
      this.deleteProspect();
    }
    else if(this.data.mode === 'contact'){
      this.deleteContact();
    }
    else if(this.data.mode === 'oportunity'){
      this.deleteOportunity();
    }
    else if(this.data.mode === 'budget'){
      this.deleteBudget();
    }
    else if(this.data.mode === 'goals'){
      this.deleteGoal();
    }
    else if(this.data.mode === 'contracts'){
      this.deleteContract();
    }

  }

  closeMdl(){
    this.mdl.close();
  }

  deleteAccount(){
    this.api.showLoading();
    this.api.deleteAccount({cuenta_id: this.data.id}).subscribe({
      next: (data: any)=>{
        setTimeout(() => {
          this.api.hideLoading();
          window.location.reload();
        }, 500);
      },
      error: (err:any)=>{
        console.error(err);
      }
    });
  }

  deleteProspect(){
    this.api.showLoading();

    this.api.deleteProspect({prospecto_id: this.data.id}).subscribe({
      next: (data:any)=>{
        setTimeout(() => {
          this.api.hideLoading();
          this.mdl.close(true)
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/prospects']);
          });
        }, 500);
      },
      error: (err)=>{
        this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar prospectos')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar prospectos')

      }
    })
  }

    deleteContact(){
    this.api.showLoading();
    this.api.deleteContact({contacto_id: this.data.id}).subscribe({
      next: (data: any)=>{
        setTimeout(() => {
          this.api.hideLoading();
          this.closeMdl();
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/contacts']);
          });
          window.location.reload();
        }, 500);
      },
      error: (err:any)=>{
                this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar contactos')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar el/los contacto/s')

      }
    });
  }


      deleteOportunity(){
    this.api.showLoading();
    this.api.deleteOportunity({oportunidad_id: this.data.id}).subscribe({
      next: (data: any)=>{
        setTimeout(() => {
          this.api.hideLoading();
          this.mdl.close(true);         
        }, 500);
      },
      error: (err:any)=>{
                this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar oportunidades')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar la oportunidad')

      }
    });
  }

      deleteBudget(){
    this.api.showLoading();
    this.api.deleteBudget({presupuesto_id: this.data.id}).subscribe({
      next: (data: any)=>{
        setTimeout(() => {
          this.api.hideLoading();
          this.closeMdl();
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/budget']);
          });
          window.location.reload();
        }, 500);
      },
      error: (err:any)=>{
                this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar presupuestos')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar el presupuesto')

      }
    });
  }

deleteGoal() {
  this.api.showLoading();
  console.log("IDs que envío al backend:", this.data.ids);

  this.api.deleteGoal({ meta_ids: this.data.ids }).subscribe({
    next: () => {
      setTimeout(() => {
        this.api.hideLoading();
        this.closeMdl();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { 
          this.router.navigate(['/goals']);
        });
      }, 500);
    },
    error: (err: any) => {
      console.error(err);
              this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar metas')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar la meta')

    }
  });
}


deleteContract(){
  this.api.showLoading();
  console.log("IDS que envio al backend:",this.data.ids)

  this.api.deletecontract({contrato_id:this.data.ids}).subscribe({
    next: ()=>{
      setTimeout(()=>{
        this.api.hideLoading();
        this.closeMdl();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { 
        this.router.navigate(['/contracts']);
      });
      }, 500);
    },
    error: (err: any) => {
              this.api.hideLoading()
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para eliminar contratos')
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al eliminar el contrato')

    }
  });
}




}
